import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_approval_setting_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  total_required_approval_level: fromDatatype.NumericDatatypeInterface;
  approval_setting_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  default_approver_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  designation_code: fromDatatype.VarcharDatatypeInterface;
  engagement_role: fromDatatype.VarcharDatatypeInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_aat_claim_approval_setting_RowClass implements bl_aat_claim_approval_setting_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  total_required_approval_level: fromDatatype.NumericDatatypeInterface;
  approval_setting_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  default_approver_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  designation_code: fromDatatype.VarcharDatatypeInterface;
  engagement_role: fromDatatype.VarcharDatatypeInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
}
